import { render } from "./Index.vue?vue&type=template&id=4a1ef780&ts=true"
import script from "./Index.vue?vue&type=script&lang=ts&setup=true"
export * from "./Index.vue?vue&type=script&lang=ts&setup=true"

import "./Index.vue?vue&type=style&index=0&id=4a1ef780&lang=scss"

import exportComponent from "/builds/easy/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/GatewayTest/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4a1ef780"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4a1ef780', __exports__)) {
    console.log('reload')
    api.reload('4a1ef780', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=4a1ef780&ts=true", () => {
    console.log('re-render')
    api.rerender('4a1ef780', render)
  })

}


export default __exports__